import styles from '@styles/scss/category/categoryTopSites.module.scss';
import { replaceUrls } from 'lib/helper/localUrls';

const languageFiles = (require as any).context('public/locales', false, /\.json$/);

export default function categoryFooterSeo({
    miniReview,
    seoText,
    faq,
    currentLang
}: {
    miniReview: string;
    seoText: string;
    faq: string;
    currentLang: string;
}): JSX.Element {
    const regex = /href=['"]([^'"]*)['"]/g;

    if (currentLang !== 'en') {
        miniReview = miniReview.replace(regex, (match, url) =>
            replaceUrls(match, url, currentLang)
        );
        seoText = seoText.replace(regex, (match, url) => replaceUrls(match, url, currentLang));
        faq = faq.replace(regex, (match, url) => replaceUrls(match, url, currentLang));
    }

    return (
        <div className={styles.footerSeoWrapper}>
            <div className={styles.footerSeoSection}>
                <div
                    className={styles.footerSeoSectionText}
                    dangerouslySetInnerHTML={{
                        __html: miniReview
                    }}></div>
            </div>
            <div className={styles.footerSeoSection}>
                <div
                    className={styles.footerSeoSectionText}
                    dangerouslySetInnerHTML={{
                        __html: seoText
                    }}></div>
            </div>
            <div className={styles.footerSeoSection}>
                <div
                    className={styles.footerSeoSectionText}
                    dangerouslySetInnerHTML={{
                        __html: faq
                    }}></div>
            </div>
        </div>
    );
}
